/** True when Chromium is rendering /p/{slug}?pdf=1 for PDF export. */
export function isPdfRenderMode(): boolean {
  try {
    if (typeof document !== "undefined") {
      if (document.documentElement.getAttribute("data-pdf") === "1") return true;
    }
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    const pdf = params.get("pdf") === "1" || params.get("print") === "1";
    if (pdf && typeof document !== "undefined") {
      document.documentElement.setAttribute("data-pdf", "1");
    }
    return pdf;
  } catch {
    return false;
  }
}
